<gp-modal #transferAccessModal [closable]="true" size="sm">
  <div class="gp-modal-title">
    <h4 class="text-ellipsis">{{ 'SETTINGS.user_rights.transfer_access_to_users' | translate }}</h4>
  </div>
  <div class="gp-modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group user-selection--info">
          <label>{{ 'SETTINGS.user_rights.transfer_access_to_users_description' | translate}}</label>
          <span
            class="text-muted">{{ 'SETTINGS.user_selected_msg' | translate:{count: selectedUserTags.length} }}
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 form-group">
        <gp-chips (removed)="removeUser($event)"
                  [(ngModel)]="selectedUserTags"
                  [displayBy]="'name'"
                  [identifyBy]="'id'">
          <gp-chips-option
            *ngFor="let option of selectedUserTags"
            [ngValue]="option">
          </gp-chips-option>
        </gp-chips>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <ng-select (typed)="fetchUsersByKeyword($event)"
                   (checked)="selectUser($event)"
                   [multiItemName]="{single: 'user', plural: 'users'}"
                   [customEmptyText]="'SETTINGS.search_user_to_select'"
                   [items]="userList"
                   [isMultiSelect]="true"
                   [placeholder]="'Select'"
                   [asyncAutoCompletion]="true"
                   class="form-control">
        </ng-select>
        <em *ngIf="isUsersLoading" class="fa fa-light fa-spinner fa-spin"></em>
        <ul class="error-list">
          <li *ngIf="!isUsersLoading && selectedUserTags?.length == 0">
            {{ 'SETTINGS.user_rights.access_transfer_minimum_one_user_required' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="gp-modal-footer">
    <button class="btn btn-dark p-x-md"
            [disabled]="selectedUserTags?.length == 0"
            (click)="transferAccess()">
      {{ 'SETTINGS.user_rights.access_transfer' | translate }}
    </button>
    <button type="button"
            class="btn btn-secondary p-x-md"
            (click)="transferAccessModal.close()">
      {{ 'FORMS.cancel' | translate }}
    </button>
  </div>
</gp-modal>
